import { FC, ReactNode } from 'react';
import { Button, ButtonIconType } from '@dynamika-shared/ui/Button/Button';
import { twMerge } from '@dynamika-shared/utils/twMerge';

type SubPageHeaderProps = {
  title: string;
  buttonText?: string;
  showButton?: boolean;
  action?: () => void;
  children?: ReactNode;
  iconType?: ButtonIconType;
  className?: string;
  headerClassName?: string;
};

export const SubPageHeader: FC<SubPageHeaderProps> = ({
  title,
  buttonText,
  showButton,
  action,
  children,
  iconType = 'plus',
  className,
  headerClassName = '',
}) => {
  return (
    <header
      data-testid='SubPageHeader'
      className={twMerge(
        'mini:mt-1 mt-2 flex items-center justify-between gap-2',
        headerClassName
      )}
    >
      <div className='info'>
        <h2 className='mini:text-[1.8rem] mini:leading-6 text-[2.4rem] font-semibold leading-8 tracking-normal'>
          {title}
        </h2>
      </div>
      <div
        className={twMerge(
          'actions flex max-w-[55rem] grow items-center justify-end gap-2',
          className
        )}
      >
        {children}
        {showButton && (
          <div>
            <Button
              iconType={iconType}
              iconClassName={'w-2 h-2'}
              className='w-[14.4rem] !border-blackOlive !bg-blackOlive text-white hover:!border-dodgerBlue  hover:!bg-dodgerBlue'
              onClick={action}
            >
              {buttonText}
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};
